import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Emits {
  (name: 'click', payload: MouseEvent): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagComponent',
  emits: ["click"],
  setup(__props, { emit }: { emit: ({
  (name: 'click', payload: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})